import config from "shared/config";
import { useEffect } from "react";
import { Institution } from "shared/institution";

type OneTrustProps = {
  institution?: Institution;
};

const OneTrust = ({ institution }: OneTrustProps) => {
  const oneTrustId = config.oneTrustId;
  const enableForInst = institution?.features?.enableOneTrust;

  useEffect(() => {
    if (!enableForInst) {
      return;
    }

    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js",
    );
    script.setAttribute("data-domain-script", oneTrustId);
    head.appendChild(script);
  }, [oneTrustId, enableForInst]);

  return null;
};

export default OneTrust;
